import { findById } from '@/utils/array/find'
import { showAlertError } from '@/utils/store/alert'
import { getQueryFrom } from '@/utils/store/getQueryFrom'

export async function loadList ({ commit, state }) {
  try {
    commit('SET_IS_LOADING', true)

    const response = await state.api.getAll(getQueryFrom(state))

    commit('SET_LIST', response.data.data)
    commit('SET_PAGINATION', response.headers)
  } catch (e) {
    showAlertError(e)
  } finally {
    commit('SET_IS_LOADING', false)
  }
}

// Обновление сущности при изменении селекта в таблице.
// Для подготовки данных к отправке можно добавить
// state.prepareFormData - функция, которая мутирует объект.
export async function updateItemSelect ({ state, dispatch }, { id, value, name, refresh = false }) {
  try {
    const item = findById(state.list, id)
    if (!item) return

    const data = {
      ...item,
      [name]: value
    }

    const dataForSend = state.prepareFormData ? state.prepareFormData(data) : data

    await state.api.update(id, dataForSend)

    // для обновления при записи данных в таблицу передавать полю с селектом refresh: true
    if (refresh) await dispatch('loadList')
    else item[name] = value
  } catch (e) {
    showAlertError(e)
  }
}

export async function requestEmail ({ state, getters }, data) {
  return state.api.sendEmail(getters.getCurrentItemId, data)
}
